
























































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import HeaderComponent from "@/components/layout/HeaderComponent.vue";
import MainComponent from "@/components/layout/MainComponent.vue";
import SidebarComponent from "@/components/layout/SidebarComponent.vue";
import ContentComponent from "@/components/layout/ContentComponent.vue";
import SidebarContentHeaderComponent from "@/components/layout/SidebarContentHeaderComponent.vue";
import EllipsisComponent from "@/components/common/parts/EllipsisComponent.vue";
import TableComponent from "@/components/common/table/TableComponent.vue";
import TheadComponent from "@/components/common/table/TheadComponent.vue";
import TbodyComponent from "@/components/common/table/TbodyComponent.vue";
import TItemComponent from "@/components/common/table/TItemComponent.vue";
import CalendarComponent from "@/components/common/parts/CalendarComponent.vue";
import CheckboxComponent from "@/components/common/parts/CheckboxComponent.vue";
import RadioComponent from "@/components/common/parts/RadioComponent.vue";
import ButtonComponent from "@/components/common/parts/ButtonComponent.vue";
import CategoryIconSelectComponent from "@/components/pages/sensors/CategoryIconSelectComponent.vue";
import ConfirmDialogComponent from "@/components/common/parts/ConfirmDialogComponent.vue";
import TimeSetDialogComponent from "@/components/common/parts/TimeSetDialogComponent.vue";
import FooterComponent from "@/components/layout/FooterComponent.vue";
import { getRoutePath } from "@/router/routes";
import {
  getAlertScheduleApi,
  postAlertScheduleApi
} from "@/typescript/api_client/emesh_api/alert_schedules/alert_schedule_api";
import {
  GetAlertScheduleResponse,
  GetTime,
  GetTimeSchedule
} from "@/typescript/api_client/emesh_api/alert_schedules/types";
import {
  SetTableTime,
  getTableTimeData
} from "@/typescript/pages/warning_stop_time/types";
import { getStoreSensorsApi } from "@/typescript/api_client/emesh_api/stores/store_sensors_api";
import {
  GetStoreSensorsResponse,
  GetStoreSensorsResponseSensor
} from "@/typescript/api_client/emesh_api/stores/types";
import { Moment } from "@/typescript/lib/common/moment";
import { fillZero } from "@/typescript/lib/common/fill_zero";

export {
  Moment,
  GetAlertScheduleResponse,
  GetTime,
  GetStoreSensorsResponse,
  GetStoreSensorsResponseSensor,
  SetTableTime,
  GetTimeSchedule
};

@Component({
  components: {
    HeaderComponent,
    MainComponent,
    SidebarComponent,
    ContentComponent,
    SidebarContentHeaderComponent,
    EllipsisComponent,
    TableComponent,
    TheadComponent,
    TbodyComponent,
    TItemComponent,
    CalendarComponent,
    CheckboxComponent,
    RadioComponent,
    ButtonComponent,
    CategoryIconSelectComponent,
    ConfirmDialogComponent,
    TimeSetDialogComponent,
    FooterComponent
  }
})
export default class WarningStopTimeEditPage extends Vue {
  // スケジュール種別
  SCHEDULE_SEQUENTIAL: number = 1;
  SCHEDULE_PERIODIC: number = 2;

  // 期間種別
  TERM_WEEKLY: number = 1;
  TERM_DAILY: number = 2;
  TERM_PERIOD: number = 3;

  // 時間対象種別
  TIME_TARGET_STORE: number = 1;
  TIME_TARGET_SENSOR: number = 2;

  isMonFlg: boolean = false;
  isTueFlg: boolean = false;
  isWedFlg: boolean = false;
  isThuFlg: boolean = false;
  isFriFlg: boolean = false;
  isSatFlg: boolean = false;
  isSunFlg: boolean = false;
  isScheduleType: boolean = true;
  isEndDate: boolean = false;
  isDayFlg: boolean = true;

  scheduleType: number = this.SCHEDULE_SEQUENTIAL;
  termType: number = this.TERM_WEEKLY;
  timeTargetType: number = this.TIME_TARGET_STORE;
  storeId: string = "";
  storeName: string = "";
  scheduleId?: number = undefined;
  startDatetime: string = "";
  endDatetime: string | null = "";
  times: GetTime[] = [];
  sensors: GetStoreSensorsResponseSensor[] = [];
  setStoreTableTimes: SetTableTime[] = [];
  setSensorTableTimes: SetTableTime[] = [];
  // 時間設定変更時使用
  dialogSetStartTime: string = "";
  dialogSetEndTime: string = "";
  setIndex: number = 0;
  setDialogStartTime: string = "";
  setDialogEndTime: string = "";

  isErrorDate: boolean = false;
  isErrorTime: boolean = false;
  isCategoriesVisible: boolean = false;
  isConfirmDialogOpen: boolean = false;
  isSetDialogOpen: boolean = false;

  closeCategory() {
    this.isCategoriesVisible = false;
  }

  setScheduleType(scheduleType: number) {
    this.scheduleType = scheduleType;
    if (this.scheduleType == this.SCHEDULE_SEQUENTIAL) {
      this.isScheduleType = true;
    } else {
      this.isScheduleType = false;
      this.termType = this.TERM_WEEKLY;
      this.isDayFlg = true;
    }
    this.setEndDate();
    this.setStartDatetime(this.startDatetime);
  }

  setTermType(termType: number) {
    this.termType = termType;
    if (this.termType == this.TERM_WEEKLY) {
      this.isDayFlg = true;
    } else {
      this.isDayFlg = false;
    }
    this.setEndDate();
    this.setStartDatetime(this.startDatetime);
  }

  setEndDate() {
    if (this.scheduleType == this.SCHEDULE_SEQUENTIAL) {
      if (this.termType == this.TERM_PERIOD) {
        this.isEndDate = true;
      } else {
        this.isEndDate = false;
      }
    } else if (this.termType == this.TERM_WEEKLY) {
      this.isEndDate = true;
    } else {
      this.isEndDate = false;
    }
  }

  setValue(key: string, value: any) {
    this[key] = value;
  }

  setTimeTargetType(timeTargetType: number) {
    this.timeTargetType = timeTargetType;
  }

  setStartDatetime(value: string) {
    this.startDatetime = new Moment("YYYY/MM/DD", value).getFormatDate();
  }

  setEndDatetime(value: string) {
    if (value == "") {
      this.endDatetime = "";
    } else {
      this.endDatetime = new Moment("YYYY/MM/DD", value).getFormatDate();
    }
  }

  // 時間設定
  setDefTimeStart(value: string) {
    this.setDialogStartTime = value;
  }

  setDefTimeEnd(value: string) {
    this.setDialogEndTime = value;
    if (this.setDialogEndTime == "00:00") {
      this.setDialogEndTime = "24:00";
    }
  }

  setTime() {
    if (this.setDialogStartTime < this.setDialogEndTime) {
      let setTableTimes: SetTableTime[] = [];
      if (this.timeTargetType == this.TIME_TARGET_STORE) {
        setTableTimes = this.setStoreTableTimes;
      } else if (this.timeTargetType == this.TIME_TARGET_SENSOR) {
        setTableTimes = this.setSensorTableTimes;
      }

      // 一旦、設定をクリア
      setTableTimes[this.setIndex].tableTimes.forEach(time => {
        if (
          this.dialogSetStartTime <= time.time &&
          this.dialogSetEndTime > time.time
        ) {
          time.setFlg = false;
        }
      });

      // 再設定
      setTableTimes[this.setIndex].tableTimes.forEach(time => {
        if (
          this.setDialogStartTime <= time.time &&
          this.setDialogEndTime > time.time
        ) {
          time.setFlg = true;
        }
      });

      this.isSetDialogOpen = false;
    }
  }

  deleteTime() {
    let setTableTimes: SetTableTime[] = [];
    if (this.timeTargetType == this.TIME_TARGET_STORE) {
      setTableTimes = this.setStoreTableTimes;
    } else if (this.timeTargetType == this.TIME_TARGET_SENSOR) {
      setTableTimes = this.setSensorTableTimes;
    }

    setTableTimes[this.setIndex].tableTimes.forEach(time => {
      if (
        this.dialogSetStartTime <= time.time &&
        this.dialogSetEndTime > time.time
      ) {
        time.setFlg = false;
      }
    });

    this.isSetDialogOpen = false;
  }

  submit() {
    this.isErrorDate = false;
    this.isErrorTime = false;
    let startDatetime = JSON.parse(JSON.stringify(this.startDatetime));
    let endDatetime = JSON.parse(JSON.stringify(this.endDatetime));
    if (this.scheduleType == this.SCHEDULE_SEQUENTIAL) {
      if (this.termType == this.TERM_WEEKLY) {
        startDatetime = new Moment(
          "YYYY/MM/DD",
          startDatetime
        ).getWeekStartDay();
        endDatetime = new Moment("YYYY/MM/DD", startDatetime).getWeekEndDay();
      } else if (this.termType == this.TERM_DAILY) {
        endDatetime = new Moment("YYYY/MM/DD", startDatetime).getFormatDate();
      }
    }
    this.validateForm(startDatetime, endDatetime);
    if (this.isErrorTime || this.isErrorDate) return;
    this.startDatetime = startDatetime;
    this.endDatetime = endDatetime;
    this.save();
  }

  save() {
    let hour = { start: "", end: "" };
    let setTableTimes: SetTableTime[] = [];
    let times: GetTime[] = [];
    if (this.timeTargetType == this.TIME_TARGET_STORE) {
      setTableTimes = this.setStoreTableTimes;
    } else {
      setTableTimes = this.setSensorTableTimes;
    }
    setTableTimes.forEach(setTableTime => {
      let timeSche: GetTimeSchedule[] = [];
      let currentTableTime: SetTableTime;
      if (this.timeTargetType == this.TIME_TARGET_STORE) {
        currentTableTime = this.setStoreTableTimes[0];
      } else {
        currentTableTime = setTableTime;
      }
      currentTableTime.tableTimes.forEach(tableTime => {
        if (tableTime.setFlg == true) {
          if (hour.start == "") {
            hour.start = tableTime.time;
          }
        } else if (hour.start != "") {
          hour.end = tableTime.time;
          timeSche.push(hour);
          hour = { start: "", end: "" };
        }
      });
      // 24時まで設定されている場合
      if (hour.start != "") {
        hour.end = "24:00";
        timeSche.push(hour);
        hour = { start: "", end: "" };
      }

      let bufferTimes: GetTime = {
        equipment_id: setTableTime.equipmentId,
        equipment_name: setTableTime.equipmentName,
        time_schedules: timeSche
      };
      times.push(bufferTimes);
    });

    if (this.endDatetime == "") {
      this.endDatetime = null;
    }
    const postData = {
      store_id: this.storeId,
      schedule_id: this.scheduleId,
      schedule_type: this.scheduleType,
      term_type: this.termType,
      start_date: this.startDatetime,
      end_date: this.endDatetime,
      sun_flg: this.termType == this.TERM_WEEKLY && this.isSunFlg ? 1 : 0,
      mon_flg: this.termType == this.TERM_WEEKLY && this.isMonFlg ? 1 : 0,
      tue_flg: this.termType == this.TERM_WEEKLY && this.isTueFlg ? 1 : 0,
      wed_flg: this.termType == this.TERM_WEEKLY && this.isWedFlg ? 1 : 0,
      thu_flg: this.termType == this.TERM_WEEKLY && this.isThuFlg ? 1 : 0,
      fri_flg: this.termType == this.TERM_WEEKLY && this.isFriFlg ? 1 : 0,
      sat_flg: this.termType == this.TERM_WEEKLY && this.isSatFlg ? 1 : 0,
      time_target_type: this.timeTargetType,
      times: times
    };
    postAlertScheduleApi(postData).then(() => {
      // WarningStopTimeShowPage に戻る
      const path = getRoutePath("WarningStopTimeShowPage", {
        store_id: this.$route.params.store_id,
        start_date: this.$route.params.start_date,
        end_date: this.$route.params.end_date
      });
      this.$router.push(path);
    });
    return null;
  }

  openDialog() {
    this.isConfirmDialogOpen = true;
  }

  closeConfirm() {
    this.isConfirmDialogOpen = false;
  }

  openSetDialog(rowIndex: number, timeIndex: number) {
    this.isSetDialogOpen = true;
    this.setIndex = rowIndex;
    let setTableTimes: SetTableTime[] = [];

    if (this.timeTargetType == this.TIME_TARGET_STORE) {
      setTableTimes = this.setStoreTableTimes;
    } else if (this.timeTargetType == this.TIME_TARGET_SENSOR) {
      setTableTimes = this.setSensorTableTimes;
    }

    if (setTableTimes[this.setIndex].tableTimes[timeIndex].setFlg) {
      // 設定されている時間帯の開始時刻
      for (let i = timeIndex; i > 0; i--) {
        if (!setTableTimes[this.setIndex].tableTimes[i].setFlg) {
          break;
        }
        this.dialogSetStartTime =
          setTableTimes[this.setIndex].tableTimes[i].time;
      }
      // 設定されている時間帯の終了時刻
      const timesLen = setTableTimes[this.setIndex].tableTimes.length;
      for (let i = timeIndex; i < timesLen; i++) {
        if (!setTableTimes[this.setIndex].tableTimes[i].setFlg) {
          break;
        }
        if (i + 1 < timesLen) {
          this.dialogSetEndTime =
            setTableTimes[this.setIndex].tableTimes[i + 1].time;
        } else {
          this.dialogSetEndTime = "24:00";
        }
      }
    } else {
      // 設定されていない場合は選択した時間帯を開始・終了時刻とする(30分単位)
      this.dialogSetStartTime =
        setTableTimes[this.setIndex].tableTimes[timeIndex].time;
      if (this.dialogSetStartTime == "23:50") {
        this.dialogSetEndTime = "24:00";
      } else if (this.dialogSetStartTime.substring(3, 5) == "00") {
        this.dialogSetEndTime = this.dialogSetStartTime.substring(0, 3) + "30";
      } else {
        this.dialogSetEndTime =
          fillZero(Number(this.dialogSetStartTime.substring(0, 2)) + 1, 2) +
          ":00";
      }
    }
  }

  closeSet() {
    this.isSetDialogOpen = false;
  }

  movePage() {
    this.$router.push(
      getRoutePath("WarningStopTimeShowPage", {
        store_id: this.$route.params.store_id,
        start_date: this.$route.params.start_date,
        end_date: this.$route.params.end_date
      })
    );
  }

  clearEndDate() {
    this.endDatetime = "";
  }

  //バリデーション関数
  validateForm(startDatetime: string, endDatetime: string) {
    if (
      endDatetime !== "" &&
      endDatetime !== null &&
      !Moment.isBefore(
        `${startDatetime} 00:00`,
        `${endDatetime} 23:50`,
        "YYYY/MM/DD HH:mm"
      )
    ) {
      this.isErrorDate = true;
    }
    const moment = new Moment("YYYY-MM-DD");
    let valiStartDate = new Moment("YYYY-MM-DD", startDatetime).getFormatDate();
    let valiEndDate = new Moment("YYYY-MM-DD", startDatetime).getFormatDate();
    if (!moment.isValid(valiStartDate)) this.isErrorDate = true;
    if (
      endDatetime !== "" &&
      endDatetime !== null &&
      !moment.isValid(valiEndDate)
    )
      this.isErrorDate = true;

    // 停止時間帯の有無チェック
    let isSetFlg = false;
    let setTableTimes: SetTableTime[] = [];
    if (this.timeTargetType == this.TIME_TARGET_STORE) {
      setTableTimes = this.setStoreTableTimes;
    } else if (this.timeTargetType == this.TIME_TARGET_SENSOR) {
      setTableTimes = this.setSensorTableTimes;
    }

    setTableTimes.some(setTableTime => {
      isSetFlg = setTableTime.tableTimes.some(tableTime => {
        if (tableTime.setFlg) return true;
      });
      if (isSetFlg) return true;
    });
    this.isErrorTime = !isSetFlg;
  }

  setEditApiData() {
    const params = {
      store_id: this.$route.params["store_id"],
      start_date: this.$route.params["start_date"],
      end_date: this.$route.params["end_date"]
    };
    getAlertScheduleApi(params).then((resp: GetAlertScheduleResponse) => {
      resp.schedules.forEach(resp => {
        if (resp.schedule_id == Number(this.$route.params["schedule_id"])) {
          this.storeId = resp.store_id;
          this.scheduleId = resp.schedule_id;
          this.setScheduleType(resp.schedule_type);
          this.setTermType(resp.term_type);
          this.startDatetime = resp.start_date;
          this.endDatetime = resp.end_date;
          this.setTimeTargetType(resp.time_target_type);
          this.times = resp.times;
          if (this.termType == this.TERM_WEEKLY) {
            this.isMonFlg = resp.mon_flg == 1 ? true : false;
            this.isTueFlg = resp.tue_flg == 1 ? true : false;
            this.isWedFlg = resp.wed_flg == 1 ? true : false;
            this.isThuFlg = resp.thu_flg == 1 ? true : false;
            this.isFriFlg = resp.fri_flg == 1 ? true : false;
            this.isSatFlg = resp.sat_flg == 1 ? true : false;
            this.isSunFlg = resp.sun_flg == 1 ? true : false;
          } else {
            this.isDayFlg = false;
          }
        }
      });
      const storeId = this.storeId;
      getStoreSensorsApi(storeId).then((resp: GetStoreSensorsResponse) => {
        this.storeName = resp.store_name;
        this.sensors = resp.sensors;
        // センサーが新規に登録された場合、時間帯が空配列となる
        // 時間対象種別が「店舗」の場合は先頭のレコードを使用するため、
        // 先頭の時間帯が空配列の場合は別のレコードからコピーする
        if (
          this.timeTargetType == this.TIME_TARGET_STORE &&
          this.times.length > 0 &&
          this.times[0].time_schedules.length == 0
        ) {
          let getTime: GetTime | undefined = this.times.find(function(time) {
            return time.time_schedules.length > 0;
          });
          if (getTime) {
            this.times[0].time_schedules = [...getTime.time_schedules];
          }
        }

        this.times.forEach((time, index) => {
          let bufferTableTime = getTableTimeData();
          let setTableTime: SetTableTime = {
            storeName: this.storeName,
            equipmentId: time.equipment_id,
            equipmentName: time.equipment_name,
            tableTimes: bufferTableTime.tableTimes
          };

          this.setStoreTableTimes.push(
            JSON.parse(JSON.stringify(setTableTime))
          );
          this.setSensorTableTimes.push(
            JSON.parse(JSON.stringify(setTableTime))
          );

          if (this.timeTargetType == this.TIME_TARGET_STORE) {
            setTableTime = this.setStoreTableTimes[index];
          } else if (this.timeTargetType == this.TIME_TARGET_SENSOR) {
            setTableTime = this.setSensorTableTimes[index];
          }

          time.time_schedules.forEach(schedule => {
            setTableTime.tableTimes.forEach(tableTime => {
              if (
                schedule.start <= tableTime.time &&
                schedule.end > tableTime.time
              ) {
                tableTime.setFlg = true;
              }
            });
          });
        });
      });
    });
  }

  setCreateApiData() {
    this.storeId = this.$route.params["store_id"];
    getStoreSensorsApi(this.storeId).then((resp: GetStoreSensorsResponse) => {
      this.storeName = resp.store_name;
      this.sensors = resp.sensors;
      this.sensors.forEach(sensor => {
        let bufferTableTime = getTableTimeData();
        let setTableTime: SetTableTime = {
          storeName: this.storeName,
          equipmentId: sensor.equipment_id,
          equipmentName: sensor.equipment_name,
          tableTimes: bufferTableTime.tableTimes
        };
        let setDate = new Moment(
          "YYYY/MM/DD",
          this.$route.params["start_date"]
        ).getFormatDate();
        this.startDatetime = setDate;
        this.endDatetime = setDate;
        this.setStoreTableTimes.push(JSON.parse(JSON.stringify(setTableTime)));
        this.setSensorTableTimes.push(JSON.parse(JSON.stringify(setTableTime)));
      });
    });
  }

  mounted() {
    if (this.$route.params["schedule_id"] == "null") {
      this.setCreateApiData();
    } else {
      this.setEditApiData();
    }
  }

  getRoutePath(pageName: string, params: {}): string {
    return getRoutePath(pageName, params);
  }
}
